var _templateObject, _templateObject2;
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var Title = styled.div.withConfig({
  displayName: "SrriBar__Title",
  componentId: "sc-12c1gzx-0"
})(["", ";text-transform:uppercase;"], function (_ref) {
  var small = _ref.small;
  return small ? getFont(-1) : getFont(0);
});
var COLORS = ['positiveDD', 'positive', 'positiveL', 'warnM', 'negativeL', 'negative', 'negativeDD'];
var Step = styled.div.withConfig({
  displayName: "SrriBar__Step",
  componentId: "sc-12c1gzx-1"
})(["z-index:10;width:", ";height:", ";margin-right:0;cursor:default;background-color:#fff;font-size:", ";line-height:", ";color:", ";text-align:center;&:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px;}&:last-child{border-right:none;border-top-right-radius:4px;border-bottom-right-radius:4px;}", " ", " ", ""], function (props) {
  return "".concat(props.width, "px");
}, function (props) {
  return "".concat(props.height, "px");
}, function (props) {
  return "".concat(props.fontSize);
}, function (props) {
  return "".concat(props.lineHeight, "px");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.srriLevelTextColor;
}, function (_ref3) {
  var checked = _ref3.checked;
  return checked && css(["background-color:", ";color:", ";"], function (_ref4) {
    var theme = _ref4.theme,
      value = _ref4.value;
    return COLORS[value - 1] ? theme.colors[COLORS[value - 1]] : theme.colors.chart6;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.srriLevelTextColorActive;
  });
}, function (_ref6) {
  var compact = _ref6.compact;
  return !compact && "margin-right: 9px;";
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref7) {
  var fluid = _ref7.fluid;
  return fluid && css(["width:100vw;height:14.2vw;line-height:14.2vw;"]);
}));
var Steps = styled.div.withConfig({
  displayName: "SrriBar__Steps",
  componentId: "sc-12c1gzx-2"
})(["display:-webkit-inline-box;z-index:10;border:1px solid ", ";border-radius:8px;background-color:#fff;", ""], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.ui;
}, maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref9) {
  var fluid = _ref9.fluid;
  return fluid && css(["width:100%;display:flex;"]);
}));
var map = {
  tiny: {
    width: 12,
    height: 8,
    lineHeight: 8,
    fontSize: '0.4rem'
  },
  small: {
    width: 24,
    height: 24,
    lineHeight: 24,
    fontSize: '0.8rem'
  },
  medium: {
    width: 32,
    height: 32,
    lineHeight: 32,
    fontSize: '1rem'
  },
  large: {
    width: 48,
    height: 48,
    lineHeight: 48,
    fontSize: '1rem'
  }
};
var SrriScale = function SrriScale(props) {
  var value = props.value,
    size = props.size,
    _props$compact = props.compact,
    compact = _props$compact === void 0 ? true : _props$compact,
    _props$fluid = props.fluid,
    fluid = _props$fluid === void 0 ? false : _props$fluid,
    _props$withTitle = props.withTitle,
    withTitle = _props$withTitle === void 0 ? false : _props$withTitle;
  var variables = map[size];
  return React.createElement(React.Fragment, null, withTitle ? React.createElement(Title, {
    small: true
  }, "Escala de riesgo") : '', React.createElement(Steps, {
    fluid: fluid
  }, [1, 2, 3, 4, 5, 6, 7].map(function (item, index) {
    return React.createElement(Step, {
      compact: compact,
      fluid: fluid,
      key: index,
      value: item,
      checked: item <= value,
      width: variables.width,
      height: variables.height,
      lineHeight: variables.lineHeight,
      fontSize: variables.fontSize
    });
  })));
};
export default SrriScale;